import React from 'react';
import person from '../Assets/person.png';
import Fade from 'react-reveal/Fade';
import {AiFillStar} from 'react-icons/ai';

const Testimonial = () => {
  return (
    <div className="work-section-wrapper">
        <Fade big top>
      <div className="work-section-top">
        <p className="primary-subheading">Testimonial</p>
        <h1 className="test-primary-heading">What They Are Saying</h1>
        <p className="primary-text">
          Lorem ipsum dolor sit amet consectetur. Non tincidunt magna non et
          elit. Dolor turpis molestie dui magnis facilisis at fringilla quam.
        </p>
      </div>
        </Fade>
        <Fade big bottom>
      <div className="testimonial-section-bottom">
        <img src={person} alt="" />
        <p>
          Lorem ipsum dolor sit amet consectetur. Non tincidunt magna non et
          elit. Dolor turpis molestie dui magnis facilisis at fringilla quam.
        </p>
        <div className="testimonials-stars-container">
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
        </div>
        <h2>David Warner</h2>
      </div>
        </Fade>
    </div>
  )
}

export default Testimonial